// src/cert/iso37001.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css'; // तुमचा CSS

const ISO37001 = () => {
    return (
        <div className="cert-page">
            {/* Header */}
            <div className="cert-header">
                <h1>ISO 37001 प्रमाणन</h1>
                <p>लाच प्रतिबंधक व्यवस्थापन प्रणाली (Anti-Bribery Management System)</p>
            </div>

            {/* Content */}
            <div className="cert-content">
                <section>
                    <h2>..ISO 37001..</h2>
                    <p>
                        The ISO 37001 standard was published in 10/2016 and provides the requirements for an enterprise to implement, maintain and improve an anti-bribery system, promoting an ethical business philosophy.
                        It includes measures and controls based on good practice and aims to cultivate a corporate culture against bribery. It is implemented by all enterprises and can be compatible with procedures, processes and control measures that exist according to existing management systems (eg quality management system according to ISO 9001).
                        The main points for implementing an anti-bribery management system are:
                        Anti-bribery policy
                        Anti-bribery compliance team
                        Risk assessment
                        Due diligence on projects and business partners
                        Carrying out financial, non-financial and contractual audits
                        Conflict of interests
                        Gift, Hospitality and Expense Policy
                        Reporting, monitoring and investigation
                        BENEFITS FROM THE IMPLEMENTATION OF ISO 37001
                        The main benefits of implementing an anti-bribery management system according to the ISO 37001 standard are the following: Reducing the risk of bribery taking place.
                        Gaining a comparative advantage in the market, especially for businesses dealing with public services Providing proof to interested parties that the company has taken all the necessary measures to avoid bribery It is a useful tool for formulating and managing a company's sustainability strategy.
                        Mobilization and active participation of staff Added value to the principles of sustainability and social responsibility already implemented by a company, cultivating an ethical business philosophy Even in the event of a bribery investigation, it provides evidence to interested parties and relevant authorities that the business had taken steps to avoid
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>लाच रोखण्यासाठी मजबूत प्रक्रिया आणि नियंत्रणे</li>
                        <li>कायदेशीर जबाबदाऱ्या पूर्ण होतात आणि दंड टाळता येतात</li>
                        <li>संस्थेची प्रतिष्ठा आणि ग्राहकांचा विश्वास वाढतो</li>
                        <li>जागतिक बाजारात स्पर्धात्मकता वाढते</li>
                        <li>कर्मचारी प्रशिक्षण आणि जबाबदारी संस्कृती विकसित होते</li>
                    </ul>
                </section>

                <section className="who-needs">
                    <h2>कोणाला हवं आहे?</h2>
                    <p>
                        ज्या संस्था जागतिक व्यापार करतात, उच्च जोखीम क्षेत्रात काम करतात किंवा लाच रोखण्यासाठी कायदेशीर/नैतिक जबाबदारी घेऊ इच्छितात —
                        IT, उत्पादन, सेवा, सार्वजनिक क्षेत्रातील कोणत्याही संस्थेसाठी उपयुक्त.
                    </p>
                </section>

                {/* Apply Form */}
                <section className="apply-section">
                    <h2>ISO 37001 साठी अर्ज करा</h2>
                    <ApplyForm certification="ISO 37001" />
                </section>
            </div>
        </div>
    );
};

export default ISO37001;